import React from "react";
import WallOfFameContent from "../function-components/WallOfFameContent";

function wallOfFame() {
  return (
    <>
      <WallOfFameContent />
    </>
  );
}

export default wallOfFame;
